namespace Matrix.Rebalancer {
    export interface ModellingViewColumnSetRow {
        ColumnSetCode?: string;
        Name?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
    }

    export namespace ModellingViewColumnSetRow {
        export const idProperty = 'ColumnSetCode';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Rebalancer.ModellingViewColumnSet';
        export const lookupKey = 'Rebalancer.ModellingViewColumnSet';

        export function getLookup(): Q.Lookup<ModellingViewColumnSetRow> {
            return Q.getLookup<ModellingViewColumnSetRow>('Rebalancer.ModellingViewColumnSet');
        }
        export const deletePermission = 'DataAdmin:Rebalancer';
        export const insertPermission = 'DataAdmin:Rebalancer';
        export const readPermission = 'Read:Rebalancer';
        export const updatePermission = 'DataAdmin:Rebalancer';

        export declare const enum Fields {
            ColumnSetCode = "ColumnSetCode",
            Name = "Name",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen"
        }
    }
}
